import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getAppConfig } from '../features/AppSlice';
import { setEnvironmentConfig } from '../services/env';

const Bootstrap = ({ children }) => {
  const [resolving, setResolving] = useState(true);
  const dispatch = useDispatch();
  const config = useSelector((state) => state.app.config);

  useEffect(() => {
    dispatch(getAppConfig());
  }, []);

  useEffect(() => {
    if (config) {
      setEnvironmentConfig(config);
      setResolving(false);
    }
  }, [config]);

  return children({
    resolving,
  });
};

Bootstrap.defaultProps = {
  //
};

Bootstrap.propTypes = {
  children: PropTypes.func.isRequired,
};

export default Bootstrap;
